import { Dispatch, SetStateAction, useState } from "react";
import {
  Input,
  Button,
  FormField,
  SpaceBetween,
  Form,
  Container,
  InputProps,
} from "@cloudscape-design/components-themed";

import { useAppSelector, useAppDispatch } from "../../app/hook";
import {
  createFormFieldErrTxts,
  clearFormFieldErrTxt,
} from "../../features/error/validation-slice";
import {
  getErrorText,
  isLengthValid,
  isNull,
} from "../../utils/inputValidation";
import { COMMON_LABELS } from "../default-constants";
import { LABELS, getCompanyTypeLabel } from "./constants";
import { createSearchCondition } from "../../features/slices/company-search";
import { CompanyNamesSearchResponse } from "../../features/api-interfaces";

interface SearchBarProps {
  companyType: string;
  setSelectedItems: Dispatch<SetStateAction<CompanyNamesSearchResponse[]>>;
  setIsSkipSearch: Dispatch<SetStateAction<boolean>>;
}

const SearchBar = ({
  companyType,
  setSelectedItems,
  setIsSkipSearch,
}: SearchBarProps) => {
  const { formFieldErrTxts } = useAppSelector((state) => state.validation);
  const dispatch = useAppDispatch();

  // ラベル
  const inputLabel = getCompanyTypeLabel(companyType) + LABELS.KANA;

  // 事業者名
  const [companyName, setCompanyName] = useState<string>("");

  /**
   * 事業者名チェック関数
   * @param value
   */
  const checkCompanyName = (value: string): boolean => {
    const name = "companyName";
    if (isNull(value)) {
      dispatch(
        createFormFieldErrTxts({
          name: name,
          msgId: "KGRERR023",
          msgArgs: [inputLabel],
        })
      );
      return false;
    } else if (!isLengthValid(value, 40)) {
      dispatch(
        createFormFieldErrTxts({
          name,
          msgId: "KGRERR024",
          msgArgs: [inputLabel, "40"],
        })
      );
      return false;
    } else {
      dispatch(clearFormFieldErrTxt(name));
      return true;
    }
  };

  /**
   * 事業者名入力関数
   * @param param
   */
  const handleCompanyNameOnChange = ({
    detail,
  }: {
    detail: InputProps.ChangeDetail;
  }) => {
    setCompanyName(detail.value);
    checkCompanyName(detail.value);
  };

  /**
   * 検索ボタン押下時
   * @param e
   */
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (checkCompanyName(companyName)) {
      setSelectedItems([]);
      setIsSkipSearch(false);
      dispatch(
        createSearchCondition({
          companyType: companyType,
          name: companyName,
          timestamp: new Date().getTime(),
        })
      );
    }
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary">{COMMON_LABELS.BTNS.SEARCH}</Button>
          </SpaceBetween>
        }
      >
        <Container>
          <SpaceBetween direction="vertical" size="l">
            <FormField
              label={inputLabel}
              errorText={getErrorText("companyName", formFieldErrTxts)}
            >
              <Input value={companyName} onChange={handleCompanyNameOnChange} />
            </FormField>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default SearchBar;
